import { IntegrationType } from 'src/constants';
import { TMenuItemType } from 'src/types/menu.types';

// Form interfaces describe the shape of the form's data
export interface IFormValues {
  name: string;
  consumerName: string;
  description?: string | null;
  defaultPrice: string;
  tax_rate: string;
  plu?: string | null;
  recipe_id: string;
  files: File | string | null;
  type: TMenuItemType;
  modifier_groups?: IFormOptionGroup[];
  price_bands?: IFormPriceBand[];
}

export interface IFormAggregator {
  aggregatorId: string;
  aggregatorName: string;
  integrationType?: IntegrationType;
  price: string;
}

export interface IFormPriceBand {
  priceBandId: string;
  name?: string;
  aggregators: IFormAggregator[];
}

export interface IFormOptionGroup {
  name: string;
  consumer_name?: string;
  description?: string;
  plu?: string | null;
  max_choices: number;
  min_choices: number;
  pk_modifier_group_id?: string;
  modifiers?: IFormOption[];
}

export interface IFormOption {
  optionItemId?: string;
  name?: string;
  posId?: string;
  parentItemId?: string;
  itemId?: string;
  type?: TMenuItemType;
  valueWithTax?: number | null;
  defaultPosId?: string;
  useDefaultPrice?: boolean;
  inheritPosId?: boolean;
}

export interface IModifierGroupObject {
  optionGroupId: string;
  modifierIds: string[];
}

export enum FormVariant {
  CREATE = 'create',
  UPDATE = 'update',
}
